import {Component, ViewChild, OnInit, AfterViewInit, ChangeDetectionStrategy} from '@angular/core';
import {IsGranted} from '../../../../decorator/is-granted';
import {MetaTitle} from '../../../../decorator/meta-title';
import {DateRangeSelectorComponent} from '../../../layout/date-range-selector/date-range-selector.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {Paginator} from '../../../../tools/pagination/paginator';
import {TableSorter} from '../../../../tools/table-sorter/table-sorter';
import {LoaderService} from '../../../../services/loader/loader.service';
import { DatePipe, NgClass } from '@angular/common';
import {PaginatorComponent} from '../../../layout/paginator/paginator.component';
import {TableSorterHeaderDirective} from '../../../../directives/table-sorter/table-sorter-header.directive';
import {TableSorterDirective} from '../../../../directives/table-sorter/table-sorter.directive';
import {DialogService} from '../../../../services/dialog/dialog.service';
import {AsyncCommand} from '../../../../models/async-command';
import {AsyncCommandService} from '../../../../services/async-command/async-command.service';
import {convertDateToApiFormat} from '../../../../tools/date/date-utils';
import {AsyncCommandDetailComponent} from './async-command-detail/async-command-detail.component';
import {AsyncCommandRunComponent} from './async-command-run/async-command-run.component';
import {RunnableCommand} from '../../../../models/runnable-command';

@Component({
  selector: 'app-async-command',
  imports: [
    DateRangeSelectorComponent,
    ReactiveFormsModule,
    DateRangeSelectorComponent,
    DatePipe,
    PaginatorComponent,
    TableSorterHeaderDirective,
    TableSorterDirective,
    FormsModule,
    NgClass
],
  templateUrl: './async-command.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './async-command.component.scss'
})
@IsGranted(['ASYNC_COMMAND_VIEW'])
@MetaTitle('Async Tasks')
export class AsyncCommandComponent implements OnInit, AfterViewInit {
  asyncCommands: AsyncCommand[] = [];
  paginator: Paginator = new Paginator();
  tableSorter: TableSorter = new TableSorter('id', 'desc');
  runnableCommands: RunnableCommand[] = [];

  @ViewChild(DateRangeSelectorComponent) dateSelector!: DateRangeSelectorComponent;

  constructor(
    private loader: LoaderService,
    private asyncCommandService: AsyncCommandService,
    private dialog: DialogService,
  ) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.refresh();
  }

  filter(): void {
    this.refresh();
  }

  refresh(): void {
    this.fetchAll();
  }

  applyFilters(): void {
    this.paginator.currentPage = 1;
    this.fetchAll();
  }

  fetchAll(): void {
    this.loader.startLoading();

    let params: any = {
      dateFrom: convertDateToApiFormat(this.dateSelector.getDateFrom()),
      dateTo: convertDateToApiFormat(this.dateSelector.getDateTo()),
    };

    this.asyncCommandService.findAll(params, this.paginator, this.tableSorter).subscribe(asyncCommands => {
      this.asyncCommands = asyncCommands;
      this.loader.stopLoading();
    });

    this.asyncCommandService.getRunnableCommands().subscribe(commands => {
      this.runnableCommands = commands;
    });
  }

  getStatusColor(status: string|null) {
    if (status === 'error') {
      return 'text-danger';
    }

    if (status === 'running') {
      return 'text-warning';
    }

    if (status === 'success') {
      return 'text-success';
    }

    return '';
  }

  openDetail(asyncCommand: AsyncCommand): void {
    this.dialog.openDialog(AsyncCommandDetailComponent, {
      class: 'modal-lg',
      data: {asyncCommand}
    }).subscribe(() => {
    });
  }

  openRun(): void {
    this.dialog.openDialog(AsyncCommandRunComponent, {
      class: 'modal-lg',
      data: {
        parentComponent: this,
        runnableCommands: this.runnableCommands,
      }
    }).subscribe(() => {
    });
  }
}
